import { takeEvery, all, call } from 'redux-saga/effects';
import { getAllGenerator, findGenerator } from 'helpers/resourceSagas';
import * as api from './api';
import * as types from './types';

export const fetchAll = getAllGenerator({
  resourceType: 'quickPlans',
  endpoint: api.fetchAll,
  endpointArgs: (payload) => [payload.subId],
  transformResponse: (resp) => resp.data.results,
});

export const find = findGenerator({
  resourceType: 'quickPlans',
  endpoint: api.find,
});

export function* watchFetchAll() {
  yield takeEvery(types.FETCH_ALL, fetchAll);
}

export function* watchFind() {
  yield takeEvery(types.FIND, find);
}

export function* watchQuickPlans() {
  yield all([
    call(watchFetchAll),
    call(watchFind),
  ]);
}
